import React from "react";
import Icon from "../Icon";
import { Button } from "./styles";

interface ScrollToTopButtonProps {
  /** window.scrollY a partir do qual o botão fica visível. */
  threshold?: number;
  /** Distância do fundo da viewport, em px — permite a página chamadora
   * evitar sobreposição com barras fixas (ex.: carrinho mobile). */
  offsetBottom?: number;
}

export default function ScrollToTopButton({
  threshold = 300,
  offsetBottom = 24,
}: ScrollToTopButtonProps) {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    function handleScroll() {
      setVisible(window.scrollY > threshold);
    }
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return (
    <Button
      type="button"
      aria-label="Voltar ao topo"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      $visible={visible}
      $offsetBottom={offsetBottom}
    >
      <Icon name="chevronDown" color="#fff" style={{ transform: "rotate(180deg)" }} />
    </Button>
  );
}
